/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import { CartTipFragment } from './cartTipFragment'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartUpdateTipVariables = Types.Exact<{
  cartUuid: Types.Scalars['String']
  tipPercentage: Types.InputMaybe<Types.Scalars['Int']>
  amountCustomTipCents: Types.InputMaybe<Types.Scalars['Int']>
}>

export type CartUpdateTip = {
  __typename: 'Root'
  cartUpdateTip: {
    __typename: 'CartUpdateTipPayload'
    cart: {
      __typename: 'Cart'
      id: number | null
      tipPercentage: number | null
      amountCustomTip: {
        __typename: 'Money'
        cents: number
        formatted: string
      } | null
    } | null
    errors: Array<{
      __typename: 'UserError'
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CartUpdateTipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CartUpdateTip' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cartUuid' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'tipPercentage' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'amountCustomTipCents' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cartUpdateTip' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartUuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cartUuid' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tipPercentage' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'tipPercentage' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'amountCustomTipCents' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'amountCustomTipCents' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'cart' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'cartTipFragment' }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    ...CartTipFragment.definitions
  ]
} as unknown as DocumentNode
export type CartUpdateTipMutationFn = Apollo.MutationFunction<
  CartUpdateTip,
  CartUpdateTipVariables
>

/**
 * __useCartUpdateTip__
 *
 * To run a mutation, you first call `useCartUpdateTip` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartUpdateTip` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartUpdateTip, { data, loading, error }] = useCartUpdateTip({
 *   variables: {
 *      cartUuid: // value for 'cartUuid'
 *      tipPercentage: // value for 'tipPercentage'
 *      amountCustomTipCents: // value for 'amountCustomTipCents'
 *   },
 * });
 */
export function useCartUpdateTip(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CartUpdateTip,
    CartUpdateTipVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<CartUpdateTip, CartUpdateTipVariables>(
    CartUpdateTipDocument,
    options
  )
}
export type CartUpdateTipHookResult = ReturnType<typeof useCartUpdateTip>
export type CartUpdateTipMutationResult = Apollo.MutationResult<CartUpdateTip>
export type CartUpdateTipMutationOptions = Apollo.BaseMutationOptions<
  CartUpdateTip,
  CartUpdateTipVariables
>
